module.exports = __webpack_public_path__ + "static/media/contact_icon.4d74b421.svg";